import { LocationEnum } from '../localization/localization.service';
import { AnalyticsConsentService } from './analytics-consent.service';
import { FirstTouchAttribution } from './types';

const FIRST_TOUCH_STORAGE_KEY = 'noblewills:first-touch-attribution:v1';
const MAX_VALUE_LENGTH = 256;

const queryFields: Record<string, keyof FirstTouchAttribution> = {
    utm_source: 'utmSource',
    utm_medium: 'utmMedium',
    utm_campaign: 'utmCampaign',
    utm_term: 'utmTerm',
    utm_content: 'utmContent',
    gclid: 'gclid',
    gbraid: 'gbraid',
    wbraid: 'wbraid',
    dclid: 'dclid',
    msclkid: 'msclkid',
    fbclid: 'fbclid',
    ttclid: 'ttclid',
    li_fat_id: 'liFatId',
};

export class FirstTouchAttributionService {
    static get(): FirstTouchAttribution | undefined {
        if (typeof window === 'undefined' || !AnalyticsConsentService.hasConsent()) return undefined;
        try {
            const value = window.localStorage.getItem(FIRST_TOUCH_STORAGE_KEY);
            if (!value) return undefined;
            const parsed = JSON.parse(value) as FirstTouchAttribution;
            return parsed.version === 1 ? parsed : undefined;
        } catch (_) {
            return undefined;
        }
    }

    static capture(locale: string, landingJurisdiction: LocationEnum): FirstTouchAttribution | undefined {
        if (typeof window === 'undefined' || !AnalyticsConsentService.hasConsent()) return undefined;

        const existing = this.get();
        if (existing) return existing;

        const params = new URLSearchParams(window.location.search);
        const attribution: FirstTouchAttribution = {
            version: 1,
            landingPath: window.location.pathname,
            locale,
            landingJurisdiction,
            capturedAt: new Date().toISOString(),
        };

        Object.entries(queryFields).forEach(([queryKey, field]) => {
            const value = params.get(queryKey)?.trim();
            if (value) attribution[field] = value.slice(0, MAX_VALUE_LENGTH) as never;
        });

        try {
            window.localStorage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify(attribution));
            return attribution;
        } catch (_) {
            return undefined;
        }
    }

    static toForwardingValue(attribution: FirstTouchAttribution | undefined): string | undefined {
        if (!attribution || typeof window === 'undefined') return undefined;
        try {
            return window.btoa(unescape(encodeURIComponent(JSON.stringify(attribution))));
        } catch (_) {
            return undefined;
        }
    }
}
